import type { FormResponseValue } from "@tellescope/types-models";

/**
 * A `Redirect` field never produces an answer — its component only navigates — so what would be
 * submitted is the empty seed from the response map, which nothing downstream reads.
 */
export const isSubmittableResponse = (response: FormResponseValue): boolean => response.answer.type !== "Redirect";
